import SEO from "../../common/SEO";
import Hero from "../pages/Hero";
import About from "../pages/About";
import Process from "../pages/Process";
import Products from "../pages/Products";
import Projects from "../pages/Projects";
import Reviews from "../pages/Reviews";
import { ExtrusionFactory, MaterialSale } from "../pages/ExtrusionSections";

export default function Home() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "H-LINE (Harekrishna Enterprise)",
    "url": "https://hline.in",
    "logo": "https://hline.in/logo.png", // We can use the actual logo URL later
    "description": "Premium manufacturing of aluminium windows, doors, facades, and louvers in Surat, Gujarat.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Surat",
      "addressRegion": "Gujarat",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91 90817 24247",
      "contactType": "sales"
    },
    "sameAs": [
      "https://www.instagram.com/hline_/",
      // Add other social links if available
    ]
  };

  return (
    <>
      <SEO
        title="Aluminium Windows & Doors Manufacturer"
        description="H-LINE specializes in high-end aluminium minimalist windows, doors, louvers, and facade systems. Manufacturing excellence in Surat since 2007."
        keywords="Aluminium windows, Slim profile doors, Architectural glazing, Surat, H-LINE, Harekrishna Enterprise, Louvers, Facade systems"
        schema={schema}
      />
      <Hero />
      <About />
      <ExtrusionFactory />
      <Process />
      <MaterialSale />
      <div className="h-0" />
      <Products />
      <Projects isHome={true} />
      <Reviews />
    </>
  );
}
